<ul>
  @for (note of notes(); track note.id) {
    <li>
      <button (click)="navigateToNote(note)">
        <span class="header" [style.--note-color]="colorMap[note.color]">
          <span class="book-data">
            <span class="chapter-data">
              <span class="chapter" nrEllipsis>{{ note.chapterTitle }}</span>
              <span class="progress">{{ note.progress | number: '1.0-0' }}%</span>
            </span>

            <span class="book-highlight" [nrEllipsis]="3">
              {{ note.selectedText }}
            </span>
          </span>

          <odl-button
            (click)="$event.stopImmediatePropagation()"
            [id]="triggerId(note.id)"
            [description]="'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate"
          >
            <odl-icon name="more_vert" slot="only-icon"></odl-icon>
          </odl-button>
          <odl-tooltip [attr.for]="'#' + triggerId(note.id)">
            {{ 'NAVIGATION.BOOKMARKS.MORE_ACTIONS' | translate }}
          </odl-tooltip>

          <odl-menu
            (click)="$event.stopImmediatePropagation()"
            [attr.for]="'#' + triggerId(note.id)"
            placement="bottom-end"
          >
            <odl-menu-item (odl-select)="navigateToNote(note)">
              <odl-icon name="arrow_forward" slot="icon"></odl-icon>
              <span>{{ 'NAVIGATION.NOTES.GO_TO' | translate }}</span>
            </odl-menu-item>
            <odl-menu-item (odl-select)="editNote(note)">
              <odl-icon name="edit" slot="icon"></odl-icon>
              <span>{{ 'NAVIGATION.NOTES.EDIT' | translate }}</span>
            </odl-menu-item>
            <odl-menu-item (odl-select)="copyNote(note)">
              <odl-icon name="copy" slot="icon"></odl-icon>
              <span>{{ 'NAVIGATION.NOTES.COPY' | translate }}</span>
            </odl-menu-item>
            <odl-menu-item (odl-select)="shareNote(note)">
              <odl-icon name="share" slot="icon"></odl-icon>
              <span>{{ 'NAVIGATION.NOTES.SHARE' | translate }}</span>
            </odl-menu-item>
            <odl-menu-item (odl-select)="deleteNote(note)">
              <odl-icon name="delete" slot="icon"></odl-icon>
              <span>{{ 'NAVIGATION.NOTES.DELETE' | translate }}</span>
            </odl-menu-item>
          </odl-menu>
        </span>

        @if (note.notes) {
          <span class="note-content">
            <span [nrEllipsis]="3">
              {{ note.notes }}
            </span>
          </span>
        }

        @if (note.sharedId) {
          <odl-tag class="shared-tag" variant="info" size="small">
            {{ 'NAVIGATION.NOTES.SHARED' | translate }}
          </odl-tag>
        }
      </button>
    </li>
  }
</ul>
